/*
POST方法：将多个学生、多个老师加入多个lesson

:param request:
  {
    "student_id_list": [4, 10, 11],  # 想要加入lessons的 school_student_id list
    "teacher_id_list": [3, 6, 9],  # 想要加入lessons的 school_teacher_id list
    "lesson_id_list": [1, 2],  # 想要加入的lesson id列表
    "conflict_tag": 1  # 0: 不考虑是否有时间冲突，即使冲突也加入lesson；1：如果冲突则全部lesson都不加入，返回冲突的lesson id；2：如果冲突则仅加入不冲突的lesson，返回冲突的lesson id
  }
*/
import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const DEFAULT_CONFLICT_TAG = 1;

export const schema = Joi.object().keys({
  'student_id_list': Joi.array().items(Joi.number().integer()),
  'teacher_id_list': Joi.array().items(Joi.number().integer()),
  'lesson_id_list': Joi.array().items(Joi.number().integer()),
  'conflict_tag': Joi.number().integer(),
});

export default function addMassLessonAndClass(classId, params) {

  if(!classId){
    throw 'missing a class ID'
  }

  let validateResult = Joi.validate(params, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  let toServer = {
    conflict_tag: DEFAULT_CONFLICT_TAG, 
    ...params,
  }

  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/a_s_t_to_lsns/${classId}/`,
		'method': 'POST',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res);
    })
    .catch((err) => {
      reject(err);
    })
  })

}



// WEBPACK FOOTER //
// ./src/controllers/controllers/lesson/addMassLessonAndClass.js